// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"698":"63034aff","727":"4bed90e7"}[chunkId] + ".chunk.js";
};